import Model from '@ember-data/model';
import attr from 'ember-data/attr';

export default class IntegrationsSegmentOutModel extends Model {
  @attr('string') key!: string;
  @attr('array', { defaultValue: () => [] }) events!: string[];
  @attr('boolean', { defaultValue: false }) resolution!: boolean;
  @attr('boolean', { defaultValue: false }) enabled!: boolean;
  @attr('boolean', { defaultValue: false }) use_javascript!: boolean;
  @attr('boolean', { defaultValue: false }) eu!: boolean;
  @attr('boolean', { defaultValue: false }) with_content!: boolean;
  @attr('boolean', { defaultValue: false }) send_cio!: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'integrations/segment-out': IntegrationsSegmentOutModel;
  }
}
